import React, { useEffect, useState } from 'react';
import { Button, Modal } from "react-bootstrap";
import CrossIcon from "../../../assets/img/file-cut-icon.png";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { useHasPermission } from '../../../hooks/useHasPermission';
import { updateCandidateStatus } from '../../../redux/slice/updateCandidateStatusSlice';
import { useForm } from 'react-hook-form';

export default function FinalCandidateStatus() {
    const { id } = useParams();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const {
        register,
        handleSubmit,
        reset,
        errors
    } = useForm();
    const [actionType, setActionType] = useState("");
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [formData, setFormData] = useState();
const [showErrorModal, setShowErrorModal] = useState(false);


    const InitialPermissionData = useSelector((state) => state.persistedReducer.forms.savedPermissions);
    const { isApprover } = InitialPermissionData ?? [];
    const canEditFinalCandidateStatus = useHasPermission("Final Update Candidate Status-manage");
    const canEdit = ((isApprover === true) || canEditFinalCandidateStatus);

    const handleActionClick = (type) => {
        handleSubmit((data) => {
            setActionType(type);
            setFormData(data);
            setShowUpdateModal(true);
        })();
    };

    const statusMapping = {
        reject: 2,
        approve: 5,
    };

    const handleStatusSubmit = async () => {
        if (!formData) {
            toast.error("Form data is missing.", { className: "toast-error-custom" });
            return;
        }
        setShowUpdateModal(false);
        const statusValue = statusMapping[actionType];
        const payload = {
            status: statusValue,
            comment: formData.commentWithStatus,
            userId: id
        };
        try {
            const response = await dispatch(updateCandidateStatus(payload)).unwrap();

            if (response?.success === true) {
                if (actionType === "approve") {
                    toast.success("Candidate has been approved successfully!", {
                        className: "toast-success-custom"
                    });
                } else {
                    toast.error("Candidate has been rejected successfully!", {
                        className: "toast-error-custom"
                    });
                }
                reset({ commentWithStatus: "" });
                setTimeout(() => {
                    navigate("/admin/candidate")
                }, 2000);
            } else {
                setShowErrorModal(true)
                toast.error(response?.reason || "Unexpected server response", {
                    className: "toast-error-custom",
                });
            }
        } catch (err) {
            toast.error(err?.message || "Server error", { className: "toast-error-custom" });
        }
        finally {
            setFormData(null);
        }
    };

    return (
        <div>
            <h5 className='review-action'>Please provide your comment and update candidate status</h5>
            <form className='comment-status-form'>
                <div className='update-status-container'>
                    <div>
                        <label htmlFor = "comment">Add Comment <span className="required">*</span></label>
                        <textarea rows={5} id="comment" placeholder='Add...' {...register("commentWithStatus", {
                            required: "comment is required to add",
                            minLength: {
                                value: 2,
                                message: "Must contain at least two characters",
                            },
                        })} />
                        {errors?.commentWithStatus && (
                            <div className="error-msg">
                                {errors.commentWithStatus.message}
                            </div>
                        )}
                    </div>
                    <div className="d-flex justify-content-end" style={{ gap: "15px" }}>
                        <button className="btn danger-btn" type="button"
                            title={
                                canEdit
                                    ? "Reject candidate"
                                    : "No permission to reject candidate"
                            }
                            disabled={!canEdit}
                            onClick={
                                canEdit
                                    ? () => handleActionClick("reject")
                                    : undefined
                            }
                        >Reject</button>
                        <button className="btn btn-primary me-2 primary-btn" type="button"
                            title={
                                canEdit
                                    ? "Approve candidate"
                                    : "No permission to approve candidate"
                            }
                            disabled={!canEdit}
                            onClick={
                                canEdit
                                    ? () => handleActionClick("approve")
                                    : undefined
                            }
                        >Approve</button>
                    </div>
                </div>
            </form>
            <Modal 
                show={showErrorModal} 
                onHide={() => setShowErrorModal(false)} 
                size="md"
            >
                <Modal.Header>
                <Modal.Title className="td-flex align-items-center mb-0">
                    Permission Denied
                </Modal.Title>
                <button
                    onClick={() => setShowErrorModal(false)} 
                    className="modal-close"
                    aria-label="Close"
                >
                    <img
                    src={CrossIcon}
                    alt="Close"
                    style={{ width: "20px", height: "20px" }}
                    />
                </button>
                </Modal.Header>
                <Modal.Body>
                <p className="fw-medium">
                    You do not have permission to approve the candidate, or your email is not configured. Kindly reach out to the <strong>admin</strong>.
                </p>
                </Modal.Body>
            </Modal>
            <Modal show={showUpdateModal} onHide={() => setShowUpdateModal(false)}>
                <Modal.Header>
                    <Modal.Title>Confirm Update Candidate Status</Modal.Title>
                    <button
                        onClick={() => setShowUpdateModal(false)}
                        className="modal-close"
                    >
                        <img
                            src={CrossIcon}
                            alt="Close"
                            style={{ width: "20px", height: "20px" }}
                        />
                    </button>
                </Modal.Header>
                <Modal.Body className='pt-0 d-flex justify-content-center'>
                    Are you sure you want to proceed?
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="cancel-cta"
                        style={{ color: "white" }}
                        onClick={() => setShowUpdateModal(false)}
                    >
                        Cancel
                    </Button>
                    <Button
                        variant="update-cta"
                        style={{ backgroundColor: "red", color: "white" }}
                        onClick={handleStatusSubmit}
                    >
                        Update
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

